import css from './H4title.module.scss';
import classNames from 'classnames';

export default function H4title({children, isWhite}) {
  return (
    <h2 className={classNames(css.h4, {[css.white]: isWhite})}>{children}</h2>
  );
}